import React, { ReactNode } from 'react';
import { IError } from '@components-shared/withErrorBoundary';
import SpareComponentAppearanceOnError from 'components/shared/withErrorBoundary/SpareComponentAppearanceOnError';

class FormGeneratorErrorGuard extends React.Component<{ children: ReactNode }> {
  state = { componentHasError: false, error: null };

  static getDerivedStateFromError(error: IError) {
    return { componentHasError: true, error };
  }

  render() {
    return this.state.componentHasError ? (
      <SpareComponentAppearanceOnError error={this.state.error} />
    ) : (
      this.props.children
    );
  }
}

export { FormGeneratorErrorGuard };
